import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import AuditorsController from './auditors.controller';
import { UserCheck } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { AuditorsTable, AuditorAnalytics } from './elements';
import { can } from '../../core/access';

class ShelfAuditors extends Inherit(AuditorsController, Component) {
    state = { auditors: [], rows: [], loading: true, exporting: null };

    render() {
        const { auditors, rows, loading, exporting } = this.state;
        // Removing auditors needs "Eliminar auditores" (Análisis Auditor can only edit pisos).
        const canRemove = can(this.user?.userType, 'auditors.remove');

        return (
            <Layout current="auditors" user={this.user}>
                {this.props.contextHolder}

                <PageHeader icon={<UserCheck />} title="Auditores" description="Gestiona el equipo de auditores" />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={3} />
                        <TableSkeleton rows={10} columns={6} />
                    </div>
                ) : (
                    <div className="space-y-6">
                        <AuditorAnalytics auditors={auditors} />

                        <AuditorsTable
                            rows={rows}
                            loading={loading}
                            auditors={auditors}
                            setRows={this.setRows.bind(this)}
                            removeAuditor={canRemove ? this.removeAuditor.bind(this) : null}
                            navigateAuditor={this.navigateAuditor.bind(this)}
                            exporting={exporting}
                            onExport={this.exportAssignments.bind(this)}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfAuditors);
